import TimeCode from '@/services/smpte_timecode.js'

const TIMECODE = {
	install (Vue, options) {
		Vue.prototype.$timecode = {

			timeCodeBuilder (durationType, duration, frameRate, dropFrame) {
				if (dropFrame === undefined) dropFrame = false
				if (durationType === 'seconds') {
					duration = Math.floor(parseFloat(duration) * frameRate)
				}
				if (durationType === 'frames') {
					duration = parseInt(duration, 10)
				}
				if (frameRate === 23.98) {
					frameRate = 23.976
				}
				let tc = new TimeCode(duration, frameRate, dropFrame)
				return tc
			}

		}
	}
}

export default TIMECODE



// WEBPACK FOOTER //
// ./src/plugins/timecode.js